module.exports = __webpack_public_path__ + "static/media/color_texto.61f5076d.png";